// @ts-nocheck
import {Column} from 'react-table'
import {EducatorInfoCell} from './EducatorInfoCell'
import {EducatorActionsCell} from './EducatorActionsCell'
import {EducatorStatusCell} from './EducatorStatusCell'
import {EducatorSelectionCell} from './EducatorSelectionCell'
import {EducatorCustomHeader} from './EducatorCustomHeader'
import {EducatorNameCell} from './EducatorNameCell'
import {EducatorAddress} from './EducatorAddressCell'
import {UserJoinedDate} from './UserJoinedCell'
import {User} from '../../core/_models'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <EducatorSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <EducatorSelectionCell id={props.data[props.row.index]._id} />,
  // },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Educator Name' className='min-w-125px' />
    ),
    id: 'basicInformation.fullName',
    Cell: ({...props}) => <EducatorNameCell educator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Email' className='min-w-125px' />
    ),
    accessor: 'basicInformation.email',
  },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Contact' className='min-w-125px' />
    ),
    accessor: 'basicInformation.contactPhone[0]',
  },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Address' className='min-w-125px' />
    ),
    id: 'basicInformation.postalAddress.streetAddress',
    Cell: ({...props}) => <EducatorAddress educator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Suburb' className='min-w-125px' />
    ),
    accessor: 'basicInformation.postalAddress.suburb',
  },
  // {
  //   Header: (props) => (
  //     <EducatorCustomHeader tableProps={props} title='Status' className='min-w-125px' />
  //   ),
  //   accessor: 'status',
  // },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Children Count' className='min-w-125px' />
    ),
    id: 'children',
    Cell: ({...props}) => <EducatorInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    id: 'status',
    Cell: ({...props}) => <EducatorStatusCell educator={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Date' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => <UserJoinedDate user={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <EducatorCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <EducatorActionsCell
        id={props.data[props.row.index]._id}
        status={props.data[props.row.index].status}
      />
    ),
  },
]

export {usersColumns}
